import { Row } from "v2/components/base/Flex/ui";

const SkeletonDot = ({
  isLoading,
  skeletonHeight = 16,
  skeletonWidth,
  dotSize = 4,
  dotColor = "#FFFFFF",
  dotSpacing = "8px",
  ...props
}: {
  isLoading: boolean;
  skeletonHeight?: number | string;
  skeletonWidth?: number | string;
  dotColor?: string;
  dotSpacing?: number | string;
} & any) => {
  const { sx, ...rest } = props;
  if (!isLoading) {
    return props.children;
  }

  return (
    <Row
      type="sc"
      sx={{
        alignItems: "center",
        gap: dotSpacing,
        width: skeletonWidth,
        height: skeletonHeight,
        ...sx,
      }}
      {...rest}>
      {[0, 1, 2].map((i) => (
        <Row
          key={i}
          sx={{
            "@keyframes dot-grow": {
              "0%, 80%, 100%": { transform: "scale(1)" },
              "40%": { transform: "scale(1.5)" },
            },
            width: dotSize,
            height: dotSize,
            borderRadius: "50%",
            background: dotColor,
            animation: "dot-grow 1.2s infinite",
            animationDelay: `${i * 0.2}s`,
          }}
        />
      ))}
    </Row>
  );
};

export default SkeletonDot;
